import { gql } from '@apollo/client';

export function getDocumentQuery(language: string, fullpath: string) {
    return gql`
        query getDocument {
            getDocument(fullpath: "/${language}/${fullpath}") {
                ... on document_page {
                    id
                    title
                    fullpath
                    type
                    creationDate
                    modificationDate
                    translations {
                        id
                        language
                    }
                    children {
                        ... on document_page {
                            id
                            title
                            fullpath
                            type
                            creationDate
                            modificationDate
                            translations {
                                id
                                language
                            }
                            children {
                                ... on document_page {
                                    id
                                    title
                                    fullpath
                                    type
                                    creationDate
                                    modificationDate
                                    translations {
                                        id
                                        language
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
}
